import React from "react";
import AuthLayout from "../layouts/auth";
import OTPVerificationForm from "../components/otp-verification-form";

function OtpVerification() {

  return (
    <AuthLayout>
      <OTPVerificationForm />
    </AuthLayout>
  );
}

export default OtpVerification;
